import {useEffect} from 'react';
import {toast} from 'sonner';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Controller, FieldErrors, useForm} from 'react-hook-form';
import {SelectOption} from '@chekin/core';
import {useOnboardingStore} from '../../store/useOnboardingStore';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';
import {useGuestCreationContext} from 'pages/Auth/context';
import {useBuildLeaderGuestOptions} from '../../hooks/useBuildLeaderGuestOptions';
import MultiRadio from 'components/common/MultiRadio';
import {Crown} from 'lucide-react';
import {StepInfoBox} from 'pages/Auth/components/StepInfoBox';
import {RadiosContent, StyledButton, Wrapper} from './styled';

type FormTypes = {
  leader_guest: SelectOption;
};
function ConfirmGuestLeaderStep() {
  const {t} = useTranslation();
  const formMethods = useForm<FormTypes>();
  const {handleSubmit, control} = formMethods;
  const {participants} = useOnboardingStore();
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {createGuests, isProcessing} = useGuestCreationContext();
  const options = useBuildLeaderGuestOptions();

  useEffect(
    function redirectIfNotParticipants() {
      if (!participants.length) {
        navigate(getFullPath(PATHS.onboarding.whoIsComing));
      }
    },
    [participants, navigate, getFullPath],
  );

  const onSubmit = (formData: FormTypes) => {
    void createGuests({customLeaderGuestId: formData?.leader_guest.value});
  };

  const onSubmitError = (errors: FieldErrors<FormTypes>) => {
    if (errors.leader_guest) {
      toast.error(t('please_select_an_option'));
    }
  };

  return (
    <Wrapper $disabled={isProcessing}>
      <StepInfoBox
        title={t('whos_in_charge')}
        description={t('select_the_the_person_in_charge_of_this_reservation')}
      />

      <RadiosContent>
        <Controller
          name="leader_guest"
          control={control}
          rules={{required: true}}
          render={({field}) => (
            <MultiRadio
              disabled={isProcessing}
              options={options}
              {...field}
              selectedOptionIcon={
                <Crown
                  size="24"
                  color="#FFD166"
                  fill="#FFD166"
                  className="top-[-1px] relative"
                />
              }
            />
          )}
        />
      </RadiosContent>
      <StyledButton
        primary
        label={t('confirm')}
        disabled={isProcessing}
        onClick={handleSubmit(onSubmit, onSubmitError)}
      />
    </Wrapper>
  );
}

export {ConfirmGuestLeaderStep};
